import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory, useParams } from 'react-router-dom';

export default function UserB2bDetails() {
  const { id } = useParams();
  const history = useHistory();

  const [user, setUser] = useState(null);
  const [saving, setSaving] = useState(false);

  const [commissions, setCommissions] = useState([]);
  const [paymentMode, setPaymentMode] = useState('card');
  const [editInfo, setEditInfo] = useState(false);
  const [editAddress, setEditAddress] = useState(false);
  const [editBilling, setEditBilling] = useState(false);
  const [showReason, setShowReason] = useState(false);
  const [reason, setReason] = useState('');
  const [actionLoading, setActionLoading] = useState(false);
  const [showAllCommissions, setShowAllCommissions] = useState(false);
  // champs modifiables
  const [companyName, setCompanyName] = useState('');
  const [phone, setPhone] = useState('');
  const [siret, setSiret] = useState('');

  const [street, setStreet] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [city, setCity] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  useEffect(() => {
    axios
      .get(`/api/b2b/${id}`)
      .then((res) => {
        setUser(res.data);
        setCommissions(res.data.commissions || []);
        setPaymentMode(res.data.paymentMode ?? 'card');
        setCompanyName(res.data.companyName || '');
        setPhone(res.data.phone || '');
        setSiret(res.data.siret || '');
        setFirstName(res.data.firstName || '');
        setLastName(res.data.lastName || '');

        setStreet(res.data.address?.street || '');
        setPostalCode(res.data.address?.postalCode || '');
        setCity(res.data.address?.city || '');
      })
      .catch((err) => {
        console.error(err);
        alert('Erreur chargement utilisateur');
      });
  }, [id]);

  const openRemoveModal = () => {
    setReason('');
    setShowReason(true);
  };

  const saveInfo = async () => {
    const { data } = await axios.patch(`/api/b2b/update/${id}`, {
      companyName,
      phone,
      siret,
      firstName,
      lastName,
    });
    setUser(data.user);
    setEditInfo(false);
  };

  const saveAddress = async () => {
    const { data } = await axios.patch(`/api/b2b/update/${id}`, {
      address: { street, postalCode, city },
    });
    setUser(data.user);
    setEditAddress(false);
  };

  const COMMISSION_ORDER = [
    'HOT',
    'SEJ',
    'CIR',
    'CRO',
    'ASS',
    'DIV',
    'VIS',
    'ADI',
    'ALT',
    'ALV',
    'ANN',
    'CCX',
    'COM',
    'EXC',
    'FRA',
    'GRT',
    'NEG',
    'RED',
    'SDP',
    'SPE',
    'SUP',
    'TER',
    'TMF',
    'TO',
    'TRF',
    'VOL',
    'VSA',
  ];

  const COMMISSION_LABELS = {
    HOT: 'Hôtel',
    SEJ: 'Séjour',
    CIR: 'Circuit',
    CRO: 'Croisière',
    ASS: 'Assurance',
    VIS: 'Visa',
    DIV: 'Divers',
  };

  const sortComms = (list = []) =>
    (list || [])
      .slice()
      .sort(
        (a, b) => COMMISSION_ORDER.indexOf(a.product) - COMMISSION_ORDER.indexOf(b.product),
      );

  const saveBilling = async () => {
    const payload = {};

    // paymentMode (checkbox)
    if (paymentMode && paymentMode !== (user.paymentMode ?? 'card')) {
      payload.paymentMode = paymentMode;
    }

    // commissions
    if (Array.isArray(commissions)) {
      payload.commissions = commissions.map((c) => ({
        product: c.product,
        rateType: c.rateType || 'Default',
        basic: Number(c.basic) || 0,
        discount: Number(c.discount) || 0,
        web: Number(c.web) || 0,
      }));
    }

    // si rien à updater
    if (Object.keys(payload).length === 0) {
      setEditBilling(false);
      return;
    }

    const { data } = await axios.patch(`/api/b2b/update/${id}`, payload);
    setUser(data.user);
    setCommissions(data.user.commissions || []);
    setEditBilling(false);
  };

  const validate = async () => {
    if (!window.confirm('Valider ce compte ?')) return;
    try {
      const { data } = await axios.patch(`/api/b2b/validate/${id}`);
      alert(data?.message || 'Compte validé');
      // reload user
      const res = await axios.get(`/api/b2b/${id}`);
      setUser(res.data);
    } catch (err) {
      const msg =
        err?.response?.data?.pgiError ||
        err?.response?.data?.message ||
        err?.message ||
        'Erreur validation';
      alert(msg);
    }
  };

  const resyncPgi = async () => {
    if (!window.confirm('Resynchroniser cet utilisateur dans PGI ?')) return;
    try {
      const { data } = await axios.patch(`/api/b2b/resync-pgi/${id}`);
      alert(`Resync PGI OK. Code: ${data.pgiAgencyCode}`);
      const res = await axios.get(`/api/b2b/${id}`);
      setUser(res.data);
    } catch (err) {
      const msg =
        err?.response?.data?.error || err?.response?.data?.message || 'Resync PGI KO';
      alert(msg);
    }
  };

  const submitRemove = async () => {
    if (!reason.trim() || reason.trim().length < 3) {
      alert('Motif obligatoire (min 3 caractères).');
      return;
    }

    if (!window.confirm('Confirmer cette action ?')) return;

    setActionLoading(true);
    try {
      const { data } = await axios.patch(`/api/b2b/remove/${id}`, { reason });
      alert(data?.message || 'OK');

      // si deleted => retour liste
      if (data?.action === 'deleted') {
        history.push('/dashboard/admin/listB2b');
        return;
      }

      // sinon reload user
      const res = await axios.get(`/api/b2b/${id}`);
      setUser(res.data);
      setShowReason(false);
    } catch (err) {
      alert(err?.response?.data?.message || 'Erreur');
    } finally {
      setActionLoading(false);
    }
  };

  const disable = async () => {
    if (!window.confirm('Désactiver ce compte ?')) return;
    try {
      const { data } = await axios.patch(`/api/b2b/disable/${id}`);
      setUser(data.user);
      alert('Compte désactivé');
    } catch (err) {
      alert(err?.response?.data?.message || 'Erreur désactivation');
    }
  };

  const fmtDate = (d) => (d ? new Date(d).toLocaleString('fr-FR') : '—');
  if (!user) return <div className="mt-4">Chargement…</div>;
  const orderedCommissions = (user?.commissions || [])
    .slice()
    .sort((a, b) => COMMISSION_ORDER.indexOf(a.product) - COMMISSION_ORDER.indexOf(b.product));

  const important = orderedCommissions.filter((c) => Number(c.basic || 0) > 0);
  const preview = important.slice(0, 4);
  const rest = orderedCommissions.length - preview.length;

  if (!user) return <div className="mt-4">Chargement…</div>;

  return (
    <div className="container mt-6">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>
          Utilisateur B2B <p style={{ fontSize: '13px', fontWeight: '100' }}>{user.email}</p>
        </h3>

        <button
          className="btn btn-outline-secondary"
          onClick={() => history.push('/dashboard/admin/listB2b')}
        >
          ← Retour
        </button>
      </div>

      <div className="card mb-3">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Informations personnelles</h5>
            <button
              className="btn btn-outline-danger btn-sm"
              onClick={() => setEditInfo((v) => !v)}
            >
              {editInfo ? 'Annuler' : 'Edit'}
            </button>
          </div>

          {!editInfo ? (
            <div>
              <div className="row">
                <div className="col-md-4">
                  <div className="text-muted">Raison sociale</div>
                  <div>{user.companyName || '—'}</div>
                </div>
                <div className="col-md-4">
                  <div className="text-muted">Nom</div>
                  <div>{user.lastName || '—'}</div>
                </div>
                <div className="col-md-4">
                  <div className="text-muted">Prénom</div>
                  <div>{user.firstName || '—'}</div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-4">
                  <div className="text-muted">SIRET</div>
                  <div>{user.siret || '—'}</div>
                </div>
                <div className="col-md-4">
                  <div className="text-muted">Téléphone</div>
                  <div>{user.phone || '—'}</div>
                </div>
              </div>
            </div>
          ) : (
            <div className="row g-2">
              <div className="col-md-4">
                <label className="form-label">Raison sociale</label>
                <input
                  className="form-control"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Nom</label>
                <input
                  className="form-control"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Prénom</label>
                <input
                  className="form-control"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">SIRET</label>
                <input
                  className="form-control"
                  value={siret}
                  onChange={(e) => setSiret(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Téléphone</label>
                <input
                  className="form-control"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              <div className="col-12 mt-2">
                <button className="btn btn-primary" onClick={saveInfo}>
                  Enregistrer
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="card mb-3">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Adresse</h5>
            <button
              className="btn btn-outline-danger btn-sm"
              onClick={() => setEditAddress((v) => !v)}
            >
              {editAddress ? 'Annuler' : 'Edit'}
            </button>
          </div>

          {!editAddress ? (
            <div>
              {user.address?.street || ''} {user.address?.postalCode || ''}{' '}
              {user.address?.city || ''}
            </div>
          ) : (
            <div className="row g-2">
              <div className="col-md-6">
                <label className="form-label">Rue</label>
                <input
                  className="form-control"
                  value={street}
                  onChange={(e) => setStreet(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">Code postal</label>
                <input
                  className="form-control"
                  value={postalCode}
                  onChange={(e) => setPostalCode(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">Ville</label>
                <input
                  className="form-control"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                />
              </div>

              <div className="col-12 mt-2">
                <button className="btn btn-primary" onClick={saveAddress}>
                  Enregistrer
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="card mb-3">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Commissions & mode de paiement</h5>
            <button
              className="btn btn-outline-danger btn-sm"
              onClick={() => setEditBilling((v) => !v)}
            >
              {editBilling ? 'Annuler' : 'Edit'}
            </button>
          </div>

          {!editBilling ? (
            <div className="row mt-3">
              {/* ✅ COMMISSIONS PREVIEW */}
              <div className="col-md-4">
                <div className="text-muted">Commissions</div>

                {(() => {
                  const ordered = sortComms(user?.commissions || []);
                  const nonZero = ordered.filter((c) => Number(c.basic || 0) > 0);
                  const preview = (nonZero.length ? nonZero : ordered).slice(0, 4);
                  const rest = ordered.length - preview.length;

                  return (
                    <div className="small mt-1">
                      {preview.map((c) => (
                        <div
                          key={c.product}
                          className="d-flex justify-content-between"
                          style={{ maxWidth: 240 }}
                        >
                          <span className="fw-semibold">
                            {c.product}
                            {COMMISSION_LABELS[c.product]
                              ? ` — ${COMMISSION_LABELS[c.product]}`
                              : ''}
                          </span>
                          <span>{Number(c.basic ?? 0)}%</span>
                        </div>
                      ))}

                      {rest > 0 && (
                        <div className="text-muted" style={{ marginTop: 4 }}>
                          +{rest} autres
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>

              {/* ✅ MODE PAIEMENT */}
              <div className="col-md-4">
                <div className="text-muted">Paiement en compte</div>
                <div className="mt-1">
                  {user.paymentMode === 'account' ? (
                    <span className="badge bg-success">Autorisé</span>
                  ) : (
                    <span className="badge bg-secondary">Non autorisé</span>
                  )}
                </div>
                <div className="text-muted small mt-1">
                  Si non autorisé, le client paiera uniquement par carte bancaire (par défaut).
                </div>
              </div>

              {/* ✅ PGI CODE */}
              <div className="col-md-4">
                <div className="text-muted">PGI code</div>
                {user.pgiAgencyCode ? (
                  <span
                    className="badge bg-info"
                    style={{ color: '#fff', padding: '.540625rem .7em', fontSize: '100%' }}
                  >
                    {user.pgiAgencyCode}
                  </span>
                ) : (
                  <span className="text-muted">—</span>
                )}
              </div>
            </div>
          ) : (
            <div className="row g-3 mt-3">
              {/* ✅ COMMISSIONS EDIT */}
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <label className="form-label mb-0">Commissions (%)</label>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="showAllCommissions"
                      checked={showAllCommissions}
                      onChange={(e) => setShowAllCommissions(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="showAllCommissions">
                      Afficher tout
                    </label>
                  </div>
                </div>

                {(() => {
                  const ordered = sortComms(commissions || []);
                  const rows = showAllCommissions
                    ? ordered
                    : ordered.filter((c) => Number(c.basic || 0) > 0);

                  return (
                    <div className="table-responsive">
                      <table className="table table-sm align-middle">
                        <thead>
                          <tr>
                            <th>Produit</th>
                            <th style={{ width: 160 }}>Basic (%)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows.map((c) => (
                            <tr key={c.product}>
                              <td>
                                <b>{c.product}</b>
                                {COMMISSION_LABELS[c.product] ? (
                                  <span className="text-muted">
                                    {' '}
                                    — {COMMISSION_LABELS[c.product]}
                                  </span>
                                ) : null}
                              </td>
                              <td>
                                <input
                                  type="number"
                                  min="0"
                                  max="100"
                                  className="form-control form-control-sm"
                                  value={c.basic ?? 0}
                                  onChange={(e) => {
                                    const v = e.target.value;
                                    setCommissions((prev) =>
                                      prev.map((x) =>
                                        x.product === c.product ? { ...x, basic: v } : x,
                                      ),
                                    );
                                  }}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <small className="text-muted">
                        Discount/Web restent à 0 automatiquement.
                      </small>
                    </div>
                  );
                })()}
              </div>

              {/* ✅ PAIEMENT EN COMPTE (checkbox) */}
              <div className="col-md-6">
                <label className="form-label d-block">Paiement en compte</label>

                <div className="form-check mt-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="allowAccountPayment"
                    checked={paymentMode === 'account'}
                    onChange={(e) => setPaymentMode(e.target.checked ? 'account' : 'card')}
                  />
                  <label className="form-check-label" htmlFor="allowAccountPayment">
                    Autoriser le paiement en compte
                  </label>
                </div>

                <small className="text-muted">
                  Si décoché, le client paiera uniquement par carte bancaire (par défaut).
                </small>
              </div>

              {/* ✅ SAVE */}
              <div className="col-12">
                <button className="btn btn-primary" onClick={saveBilling} disabled={saving}>
                  {saving ? 'Enregistrement…' : 'Enregistrer'}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="card mb-3">
        <div className="card-body">
          <h5 className="mb-0">Actions</h5>
          <hr />

          <div className="d-flex gap-2 flex-wrap">
            {user.status === 'valid' && (
              <button
                className="btn btn-outline-primary"
                onClick={resyncPgi}
                style={{ marginRight: '1rem' }}
              >
                🔄 Resync PGI
              </button>
            )}
            {user.status === 'pending' && (
              <button
                className="btn btn-success"
                onClick={validate}
                style={{ marginRight: '1rem' }}
              >
                Valider
              </button>
            )}

            <button className="btn btn-danger" onClick={openRemoveModal}>
              {user.status === 'pending' ? '🗑️ Supprimer' : '⛔ Désactiver'}
            </button>
          </div>
        </div>
      </div>
      {showReason && (
        <div
          className="modal d-block"
          tabIndex="-1"
          role="dialog"
          style={{ background: 'rgba(0,0,0,.4)' }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {user.status === 'pending'
                    ? 'Motif de suppression'
                    : 'Motif de désactivation'}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowReason(false)}
                />
              </div>

              <div className="modal-body">
                <textarea
                  className="form-control"
                  rows={4}
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Ex: informations incomplètes, documents non conformes, compte dupliqué..."
                />
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => setShowReason(false)}
                >
                  Annuler
                </button>
                <button
                  className="btn btn-danger"
                  onClick={submitRemove}
                  disabled={actionLoading}
                >
                  Confirmer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
